import styles from './Timeline.module.css'

interface Props {
  index: number
}

const DAYS = [0, 1, 2, 3, 4]

export const WeekTechnicianRowSkeleton = ({ index }: Props) => (
  <div
    className={`w-full flex items-stretch ${styles.skeletonRow}`}
    style={{ animationDelay: `${index * 80}ms` }}
  >
    {/* TechnicianInfo placeholder */}
    <div className="w-56 shrink-0 self-stretch p-3 bg-white outline outline-1 outline-offset-[-0.50px] outline-slate-200 flex items-center gap-3.5 sticky left-0 z-10">
      <div className="w-11 h-11 rounded-full bg-slate-200 shrink-0" />
      <div className="flex-1 min-w-0 flex flex-col gap-2">
        <div className="h-3 bg-slate-200 rounded-sm w-24" />
        <div className="h-3 bg-slate-200 rounded-sm w-16" />
      </div>
    </div>

    {/* Week cells placeholder */}
    <div className="flex-1 grid grid-cols-5 min-w-0">
      {DAYS.map((day) => {
        const showPill = (index + day) % 3 !== 2
        return (
          <div
            key={day}
            className="min-h-[64px] p-1 flex flex-col gap-0.5 outline outline-1 outline-offset-[-0.5px] outline-slate-200 bg-white"
          >
            {showPill && <div className="h-4 bg-slate-200 rounded-sm w-full" />}
          </div>
        )
      })}
    </div>
  </div>
)
